function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -0.1rem;\n  right: -0.3rem;\n  font-size: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  background-color: ", ";\n  color: ", ";\n  padding: 0.2rem 0.4rem;\n  border-radius: 0.75rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n\n  ", " {\n    cursor: pointer;\n  }\n\n  &:hover {\n    animation-duration: 0.35s;\n    animation-fill-mode: both;\n    animation-timing-function: linear;\n    animation-iteration-count: 2;\n    animation-name: bounce;\n  }\n\n  @keyframes bounce {\n    0%,\n    to {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.2);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../../theme";
import { AppIconStyle } from "../../appIcon/AppIcon.styles";
export var MessageCounterWrapper = styled.div(_templateObject(), AppIconStyle);
export var MessageCount = styled.div(_templateObject2(), function (props) {
  return props.theme.variables.fonts.size.smaller3;
}, function (props) {
  return props.theme.variables.fonts.weight.regular;
}, function (props) {
  return props.theme.variables.typography.secondaryFont;
}, function (props) {
  return props.theme.variables.colors.cardinal;
}, function (props) {
  return props.theme.variables.colors.white;
});